import { render } from "./AccountingSetting.vue?vue&type=template&id=e4261ef0&ts=true"
import script from "./AccountingSetting.vue?vue&type=script&lang=ts"
export * from "./AccountingSetting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__